import { httpGet, httpPost } from "@/request/http";

let path = "/member-degree-rules";

export default {
  getAll() {
    return httpGet(`${path}/all`);
  },
  get(dTO) {
    return httpGet(path, dTO);
  },
  save(item) {
    return httpPost(path, item);
  },
  getHistory(type, dTO) {
    return httpGet(`/action-logs/type/${type}/pages`, dTO);
  },
};
